function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#105568",
  d: "M50.5 16.4s1.8 2.1 4.2 2.1c1.1 0 1.9-.4 1.9-1.4 0-2-7.4-2-7.4-6.5 0-2.8 2.5-4.1 5.5-4.1 1.9 0 4.9.6 4.9 2.9v1.5h-3.1v-.7c0-.7-1-1-1.8-1-1.2 0-2.1.4-2.1 1.3 0 2.2 7.5 1.8 7.5 6.5 0 2.6-2.3 4.3-5.4 4.3-3.9 0-5.8-2.5-5.8-2.5l1.6-2.4zM68.4 6.5c4 0 6.2 3 6.2 6.7v1.3h-9.8c.3 2.5 2.1 3.8 4.2 3.8 2.3 0 3.9-1.6 3.9-1.6l1.8 2.2s-2.4 2.3-5.9 2.3c-4.7 0-7.6-3.4-7.6-7.4.1-4.3 3-7.3 7.2-7.3zm2.7 5.5c-.1-1.7-1.2-2.8-2.6-2.8-1.8 0-3.1 1.1-3.4 2.8h6zM77.4 9.3h-2V6.5h2.1V3h3.1v3.5h3.5v2.8h-3.5v6c0 2.7 2.1 2.9 3.1 2.9.4 0 .6-.1.6-.1v3.1s-.4.1-1.1.1c-2 0-5.8-.6-5.8-5.3V9.3zM40.4 16.8c-.1 0-.2.1-.2.2v.4h-1v-1.2c0-.5.2-.7.6-.7h2.1c-.5-.2-1-.8-1-1.7 0-1.1.6-1.7 1.9-1.7h1.9c.1 0 .2-.1.2-.2v-.4h1v1.2c0 .5-.2.6-.7.6h-2.3c-.6 0-1 .2-1 .8 0 .6.4 1.1 1 1.3.2.1.4.1.6.1H46v1.2h-5.6zM1.7 16.4s1.8 2.1 4.2 2.1c1.1 0 1.9-.4 1.9-1.4 0-2-7.4-2-7.4-6.5 0-2.8 2.5-4.1 5.5-4.1 1.9 0 4.9.6 4.9 2.9v1.5H7.6v-.7c0-.7-1-1-1.8-1-1.2 0-2.1.4-2.1 1.3 0 2.2 7.5 1.8 7.5 6.5 0 2.6-2.3 4.3-5.4 4.3C2 21.2 0 18.7 0 18.7l1.7-2.3zM19.6 6.5c4 0 6.2 3 6.2 6.7v1.3H16c.3 2.5 2.1 3.8 4.2 3.8 2.3 0 3.9-1.6 3.9-1.6l1.8 2.2s-2.4 2.3-5.9 2.3c-4.7 0-7.6-3.4-7.6-7.4 0-4.3 2.9-7.3 7.2-7.3zm2.6 5.5c-.1-1.7-1.2-2.8-2.6-2.8-1.8 0-3.1 1.1-3.4 2.8h6zM28.5 9.3h-2V6.5h2.1V3h3.1v3.5h3.5v2.8h-3.5v6c0 2.7 2.1 2.9 3.1 2.9.4 0 .6-.1.6-.1v3.1s-.4.1-1.1.1c-2 0-5.8-.6-5.8-5.3V9.3z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#105568",
  d: "M41.5 20.5v.8h-1v-.8h-1.3v-1.2h1.3V18h1v1.3h2.3c1 0 1.1-.8 1.1-1.2v-.2H46v.4c0 .7-.2 2.2-2 2.2h-2.5z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#105568",
  d: "M40.4 8.9c0-1.5 1.1-2.3 2.5-2.3h.5v3.7c.9-.1 1.4-.8 1.4-1.6s-.6-1.5-.6-1.5l.8-.7s.9.9.9 2.2c0 1.7-1.3 2.8-2.8 2.8-1.5 0-2.7-1.1-2.7-2.6zm2.1-1c-.6 0-1.1.5-1.1 1 0 .7.4 1.1 1.1 1.3V7.9z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 103.9,
  cy: 12.1,
  r: 12.1,
  fill: "#39a4a1"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "SVGID_1_",
  cx: 103.9,
  cy: 12.1,
  r: 12.1
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_2_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_1_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M111.8 20.2c-5.7 3.2-11.5 3.7-11.3 3.6 5.8-1.1 9.1-5.2 9.1-5.2 1.5 1.9 2.2 1.6 2.2 1.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#105568",
  d: "M95.8 4.4v19.4s4 .1 4.8 0c.8-.1 4.8-.5 9.1-5.2 0 0 1.5 2.6 2.2 1.6 0 0 .3-2.4.1-15.7l-16.2-.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M102.1 12.6c-.1-1.3-1.2-2.3-2.5-2.2s-2.3 1.2-2.2 2.5c.1 1.3 1.2 2.3 2.5 2.2 1.3-.2 2.3-1.3 2.2-2.5zm-1 .3c-.1.1-1.9 1.2-1.9 1.2-.1 0-.2-.1-.2-.3v-2.2c0-.1.1-.3.3-.2l1.8 1.2s.2.1 0 .3zM99.253 4.165l8.984-.525.111 1.896-8.985.526zM103.5 10.7h6v.6h-6zM103.5 12.4h6v.6h-6zM103.5 14.1h6v.6h-6z"
})));

var SvgLightLogoLarge = function SvgLightLogoLarge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 24.2,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLightLogoLarge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LightLogoLarge.b3e646ea.svg";
export { ForwardRef as ReactComponent };